/*eslint-disable*/
import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      keepAlive: true,
      banner:true,
      title:'汉高机器人（深圳）有限公司'
    }
  },
  {
    path: '/product',
    name: 'Product',
    component: () => import('../views/Product.vue'),
    meta: {
      keepAlive: true,
      banner:true,
      title:'产品中心'
    }
  },
  {
    path: '/pDetails',
    name: 'productDetails',
    component: () => import('../views/productDetails.vue'),
    meta: {
      keepAlive: true,
			banner:false,
      title:'产品详情'
    }
  },
  {
    path: '/video',
    name: 'Video',
    component: () => import('../views/Video.vue'),
    meta: {
      keepAlive: true,
      banner:true,
      title:'应用视频'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
    meta: {
      keepAlive: true,
      banner:true,
      title:'关于汉高'
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue'),
    meta: {
      keepAlive: true,
      banner:false,
      title:'联系我们'
    }
  },
  {
    path: '/download',
    name: 'Download',
    component: () => import('../views/Download.vue'),
    meta: {
      keepAlive: true,
      banner:true,
      title:'产品资料'
    }
  },
	{
	  path: '/debug',
	  name: 'Debug',
	  component: () => import('../views/Debug.vue'),
	  meta: {
	    keepAlive: true,
	    banner:true,
	    title:'调试软件下载'
	  }
	},
	{
	  path: '/other',
	  name: 'Other',
	  component: () => import('../views/Other.vue'),
	  meta: {
	    keepAlive: true,
	    banner:true,
	    title:'其他文件'
	  }
	},
  {
    path: '/shoppingcar',
    name: 'ShoppingCar',
    component: () => import('../views/ShoppingCar.vue'),
    meta: {
      keepAlive: false,
			banner:false,
      title:'个人中心-购物车'
    }
  },
  {
    path: '/payorder',
    name: 'PayOrder',
    component: () => import('../views/PayOrder.vue'),
    meta: {
      keepAlive: false,
			banner:false,
      title:'个人中心-采购订单'
    }
  },
  {
    path: '/address',
    name: 'Address',
    component: () => import('../views/Address.vue'),
    meta: {
      keepAlive: false,
			banner:false,
      title:'个人中心-收货地址'
    }
  },
  {
    path: '/settlement',
    name: 'Settlement',
    component: () => import('../views/Settlement.vue'),
    meta: {
      keepAlive: false,
			banner:false,
      title:'个人中心-结算'
    }
  },
  {
    path: '/offline',
    name: 'Offline',
    component: () => import('../views/Offline.vue'),
    meta: {
      keepAlive: false,
  		banner:false,
      title:'支付页面'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
